import {jsx} from 'snabbdom-jsx-lite';

import {BannerEl} from 'common/components/banner';
import {ActionEvent, BannerAction, BannerSize, BannerType} from 'common/components/banner/types';
import {Store} from 'common/report/stores/store';
import {SavedReportsLimit} from 'common/report/stores/saved-reports-limit';
import {trackUpsellEvent} from 'common/report/util/tracking-helpers';

export function savedReportsLimitBannerRenderer(
  savedReportsLimitStore: Store<Record<string, SavedReportsLimit>>,
  projectId: number,
  bannerClass = ``,
) {
  const savedReportsLimit: SavedReportsLimit = savedReportsLimitStore.value[projectId] ?? {
    hasFiniteLimit: false,
    isBelowLimit: false,
  };
  if (savedReportsLimit.hasFiniteLimit) {
    const bannerSel = bannerClass ? `.${bannerClass}` : ``;
    return (
      <BannerEl
        sel={bannerSel}
        attrs={{
          theme: savedReportsLimit.isBelowLimit ? `info` : `warn`,
          type: BannerType.Embedded,
          size: BannerSize.Medium,
          'header-text': `${savedReportsLimit.savedReportsCount} of ${savedReportsLimit.finiteLimit} Saved Reports`,
          'body-text': `Your current plan allows ${savedReportsLimit.finiteLimit} saved reports per user per project. Upgrade your plan to save unlimited reports.`,
          ctas: [
            {
              actionName: BannerAction.Upgrade,
              text: `Upgrade`,
              icon: `share`,
              href: `/pricing`,
            },
          ],
          'style-override': `.banner-wrapper .banner-panel .banner-copy {width: calc(100% - 130px)}`,
        }}
        on={{
          action: (ev: ActionEvent) => {
            if (ev.detail.actionName === BannerAction.Upgrade) {
              trackUpsellEvent(`Click Upsell`, `bookmark`);
            }
          },
        }}
      />
    );
  }

  return null;
}

export function canSaveNewReports(
  savedReportsLimitStore: Store<Record<string, SavedReportsLimit>>,
  projectId: number,
): boolean {
  return savedReportsLimitStore.value[projectId]?.isBelowLimit ?? false;
}
